module.exports = __webpack_public_path__ + "img/index_inTest.14c1b9e4.png";